import { call, put, takeLatest, select } from "@redux-saga/core/effects";
import { jarvisOnestockOnboardingApis } from "./jarvisOnestockOnboardingApis";
import { jarvisOnestockOnboardingParser } from "./jarvisOnestockOnboardingParser";
import { jarvisOnestockOnboardingConstants } from "./jarvisOnestockOnboardingConstants";
import { jarvsiOnestockOnboardingActions } from "./jarvisOnestockOnboardingAction";
import { mergeKycWithLoginProfile } from "helper/ckycPrefill";

function* getOnboardingDataSaga() {
    try {
        yield put({
            type: jarvisOnestockOnboardingConstants.ONESTOCK_ONBOARDING_DATA_REQUEST,
        });

        const res = yield call(jarvisOnestockOnboardingApis.getOnboardingData);
        const payload = jarvisOnestockOnboardingParser.onboardingData(res);
        const loginProfile = yield select((state) => state.customer.loginProfile);

        yield put({
            type: jarvisOnestockOnboardingConstants.ONESTOCK_ONBOARDING_DATA_RESPONSE,
            payload,
        });

        const kyc = mergeKycWithLoginProfile(payload, loginProfile);

        yield put(
            jarvsiOnestockOnboardingActions.updateOnestockOnboardingData({
                panNumber: kyc.panNumber,
                dateOfBirth: kyc.dateOfBirth,
                aadharNumber: kyc.aadharNumber,
            }),
        );
    } catch (e) {
        yield put({
            type: jarvisOnestockOnboardingConstants.ONESTOCK_ONBOARDING_DATA_RESPONSE,
            payload: {},
        });
    }
}

export function* registerJarvisOnestockOnboardingSagas() {
    
    yield takeLatest(
        jarvisOnestockOnboardingConstants.ONESTOCK_ONBOARDING_DATA_SAGA,
        getOnboardingDataSaga
    );
    
}
